module.exports = __webpack_public_path__ + "img/female_vampire_desk.fa401236.jpg";